import { render, staticRenderFns } from "./AddMoleculeComponent.vue?vue&type=template&id=a126c410&"
import script from "./AddMoleculeComponent.vue?vue&type=script&lang=js&"
export * from "./AddMoleculeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports